import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const WaterResistance = ({ onWaterResistanceSelected }) => {
  const [selectedWaterResistance, setSelectedWaterResistance] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.waterresistance) {
        const waterResistanceObject = firstResult.waterresistance;
        if (waterResistanceObject.trim() !== "") {
          setVariations(waterResistanceObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleWaterResistanceClick = (waterresistance) => {
    setSelectedWaterResistance(waterresistance);
    onWaterResistanceSelected(waterresistance);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Water Resistance:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedWaterResistance === variation ? "selected" : ""}`}
            onClick={() => handleWaterResistanceClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default WaterResistance;
